import { render, staticRenderFns } from "./SefosCertificate.vue?vue&type=template&id=3c4a1f54"
import script from "./SefosCertificate.vue?vue&type=script&lang=js"
export * from "./SefosCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports